import { Response } from '../../../../generic/v2/response/response';
import { AutomationRequestName } from '../../../automation-request-name';

export abstract class AutomationResponse<T> extends Response<AutomationRequestName, T> {}
